<template>
  <div>
    <p class="show-graph-data-btn"><a @click="toggle"><b-icon pack="fas" :icon="this.visible ? 'caret-up' : 'caret-down'" /></a></p>
    
    <CommonTable
      v-show="this.visible"
      :data="tableitems"
      :config="config">
      <template slot-scope="props">
        <b-table-column field="time" :label="$t('app.dashboard.table.time')"  sortable>
          {{ props.row.time }}
        </b-table-column>
        <b-table-column field="value" :label="$t('app.dashboard.table.value')" sortable class="level-right">
          {{ props.row.value }}
        </b-table-column>
      </template>
    </CommonTable>
  </div>
</template>
<script>
import moment from "moment";
import CommonTable from '../../view/CommonTable'

export default {
  components: {CommonTable},
  props: {
    plotdata: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      config: {
        mobileCard: false,
        hoverable: true,
        perPage: 50,
        checkable: false
      },
      visible: false,
    };
  },
  computed: {
    tableitems: function() {
      let obj = []; //データの初期化
      for (let i = 0; i < this.plotdata.length; i++) {
        obj.push({
            value: Number(this.plotdata[i].y),
            time: moment(this.plotdata[i].x).format("YYYY-MM-DD HH:mm:ssZ")
        });
      }

      //複数変数の場合の表生成
      /* 
      for (let j = 0; j < this.plotdata.length; j++) {
        if (j == 0 && this.plotdata.length >= 2) {
          obj.push({ value: "", time: this.variableName[j].Name });
        } else if (j != 0 && this.plotdata.length >= 2) {
          obj.push({ value: "", time: "" });
          obj.push({ value: "", time: this.variableName[j] });
        }
        for (let i = 0; i < this.plotdata[j].length; i++) {
          obj.push({
            value: Number(this.plotdata[j][i].y),
            time: moment(this.plotdata[j][i].x).format("YYYY-MM-DD HH:mm:ssZ")
          });
        }
      }
      */

      return obj;
    }
  },
  methods: {
    toggle() {
      this.visible = !this.visible;
    }
  }
};
</script>
<style>
.show-graph-data-btn {
  margin: 20px 0;
}
.show-graph-data-btn a {
  display: block;
  position: relative;
  height: 46px;
  border-radius: 4px;
  background: #ccc;
  text-decoration: none;
  color: #333;
}
.show-graph-data-btn a i {
  position: absolute;
  font-size: 3rem;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.show-graph-data-btn.open a i {
  transform: scale(1, -1) translateX(-50%) translateY(50%);
}
#hidden-graph-data {
  display: none;
}
</style>
